import {CommonMessages} from '../common.messages';

export const PanelAccountsEditPublicPortfolioMessages = {
    GetPublicPortfolioFailed: {
        key: 'GetPublicPortfolioFailed',
        message: 'Error while communication with the server. Can\'t load the public portfolio.'
    },
    UnpublishCaption: {
        key: 'UnpublishCaption',
        message: 'Unpublish "<<name>>"?'
    },
    UnpublishQuestion: {
        key: 'UnpublishQuestion',
        message: 'The public profile becomes invisible immediately and all <b><<followers>> followers</b> are removed. '
            + 'The immutable Public Portfolio ID and the private history are retained; the client may re-publish later. '
            + 'This action is audited.'
    },
    UnpublishSucceeded: {
        key: 'UnpublishSucceeded',
        message: 'The public portfolio was unpublished.'
    },
    UnpublishNotPublished: {
        key: 'UnpublishNotPublished',
        message: 'The portfolio is no longer published; nothing to unpublish.'
    },
    UnpublishFailed: {
        key: 'UnpublishFailed',
        message: 'Error while communication with the server. The portfolio could not be unpublished.'
    },
    RenameSucceeded: {
        key: 'RenameSucceeded',
        message: 'The public portfolio was renamed.'
    },
    RenameNameTaken: {
        key: 'RenameNameTaken',
        message: 'The client already has a portfolio with this name.'
    },
    RenameNameInvalid: {
        key: 'RenameNameInvalid',
        message: 'The portfolio name must be 1 to 20 characters: letters, digits, spaces, the apostrophe and . , & - _ ( ) only.'
    },
    RenameFailed: {
        key: 'RenameFailed',
        message: 'Error while communication with the server. The portfolio could not be renamed.'
    },
    PortfolioMissing: {
        key: 'PortfolioMissing',
        message: 'This account has no public portfolio; the tab was refreshed.'
    },
    CommandNotConfirmed: {
        key: 'CommandNotConfirmed',
        message: 'The server did not confirm the change; the tab shows the current state.'
    },
    PublicPortfolioForbidden: {
        key: 'PublicPortfolioForbidden',
        message: 'You are not allowed to manage this public portfolio: an active operator with the trading-accounts edit right is required.'
    },
    PreparationFailedUnknown: {
        key: 'PreparationFailedUnknown',
        message: 'The last publication attempt did not complete.'
    },
    AttemptPreparingSince: {
        key: 'AttemptPreparingSince',
        message: 'since'
    },
    AttemptFailed: {
        key: 'AttemptFailed',
        message: 'Last attempt failed: <<reason>>'
    },
    StatePublished: {
        key: 'StatePublished',
        message: 'Published'
    },
    StateUnpublished: {
        key: 'StateUnpublished',
        message: 'Unpublished'
    },
    StateNotPublished: {
        key: 'StateNotPublished',
        message: 'Not published'
    },
    StatePreparing: {
        key: 'StatePreparing',
        message: 'Preparing'
    },
    ...CommonMessages
};

/** Operator-readable text per failure reason of a publication attempt; a reason outside this list gets PreparationFailedUnknown. */
export const PublicPortfolioFailureReasonTexts: {[reason: string]: string} = {
    LifetimeHistoryIncomplete: 'Reporting could not build the account\'s complete trade history.',
    ProjectionFailed: 'Reporting could not build the public projection.',
    PublishRightRevoked: 'The publishing right was revoked while the publication was being prepared.',
    AccountInactive: 'The account stopped being active while the publication was being prepared.',
    OccurrenceClosed: 'The publication was closed before it was ready.',
    PreparationTimedOut: 'Reporting did not confirm the publication in time.'
};
